import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';

function BarChart(props) {
  const chartContainer = useRef(null);
  let typeChart = props.type;

  useEffect(() => {
    let chartInstance = null;
    
    if (chartContainer && chartContainer.current) {
      if (chartInstance) {
        chartInstance.destroy();
      }

      chartInstance = new Chart(chartContainer.current, {
        type: 'bar',
        data: {
          labels: props.labels,
          datasets: [{
            label: '_',
            backgroundColor: [
                'rgb(255, 99, 132)',
                'rgb(54, 162, 235)',
                'rgb(255, 205, 86)',
                'rgb(128, 0, 128)',
                'rgb(0, 128, 0)',
                'rgb(255, 0, 0)',
                'rgb(0, 0, 255)',
                'rgb(128, 128, 0)',
                'rgb(0, 128, 128)',
                'rgb(192, 192, 192)',
                'rgb(255, 165, 0)',
                'rgb(255, 0, 255)',
                'rgb(0, 255, 255)',
                'rgb(128, 0, 0)',
                'rgb(0, 128, 128)',
                'rgb(0, 0, 128)',
                'rgb(0, 255, 0)',
                'rgb(128, 128, 128)',
                'rgb(128, 128, 255)',
                'rgb(128, 0, 128)'
              ],
              
            data: props.data,
            
          }]
        },
        options: {
          height: 300,
          plugins: {
            legend: {
                display: false,
                position: props.position,
                labels: {
                    color: 'rgb(255, 99, 132)'
                }
            }
        }
          
        }
      });
    }
  
    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, [chartContainer, props]);
  

  return (
    <div className="w-full">
      <canvas className='w-full' ref={chartContainer} />
    </div>
  );
}

export default BarChart;
